import { cn } from '@reelplicate/ui/lib/utils';

/**
 * shadcn Skeleton restyled to the Figma bone: bg/muted, clipped, no pulse (the
 * Figma shimmer lives in the public `Skeleton`, lib/skeleton.tsx). Decorative:
 * hidden from assistive tech - mark the loading region `aria-busy` instead.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      aria-hidden
      data-slot="skeleton"
      className={cn('bg-bg-muted relative overflow-hidden rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
